import { createContext } from "react";

export type UserSettings = {
  initialized: boolean,
  saveSetting: (key: string, value: any) => void
  settings: { [key: string]: any, }
}

export const defaultUserSettings = {
  initialized: false,
  saveSetting: () => {},
  settings: {},
};

Object.freeze(defaultUserSettings);

export const UserSettingContext = createContext<UserSettings>(defaultUserSettings);